
import { CalendarService } from "@/services/calendar-service";
import Vue from "vue";
import { Calendar } from "../../models/calendar";
import AppCalendarListItem from "./CalendarListItem.vue";

export default Vue.extend({
	props: {
		calendar: {
			type: Object as () => Calendar,
			required: true
		},
		active: {
			type: Boolean
		}
	},
	methods: {
		edit() {
			this.$emit("edit");
		},
		async remove() {
			let res = await this.$confirmBuilder().setWarningTitle().setMessage(this.$ct("confirm-calendar-delete", {name: this.calendar.Name})).show();
			if (!res) {
				return;
			}
			await CalendarService.deleteCalendars([this.calendar]);
			this.$emit("delete");
		},
		load() {
			this.$emit("load");
		}
	},
	components: {
		AppCalendarListItem
	},
	i18nEx: {
		componentPrefix: "components.calendar"
	}
});
